export default () => {
  return {
    container: ({ spacingHeight }) => ({
      margin: 0,
      height: `${spacingHeight}px`,
    }),
  }
}
